<!--
 * @Description: 委托代开-未支付列表
 * @Date: 2025-06-11 16:21:13
-->

<template>
  <BaseDialog
    width="950px"
    class="form-dialog form-dialog--label120"
    title="申请开票"
    :model-value="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
  >
    <BaseTextContent>
      <XrkTable
        ref="xrkTableRef"
        :getListAjax="getListAjax"
        :searchConfig="searchConfig"
        :tableConfig="tableConfig"
      >
        <template #tableBefore>
          <div style="text-align: right">
            <span style="margin-right: 15px">
              价税合计：{{ formatter.fen2yuan(selectionUserDefinedPrice) }}元
            </span>
            <span>最大开票金额：{{ formatter.fen2yuan(totalPrice) }}元</span>
          </div>
        </template>
      </XrkTable>
    </BaseTextContent>
    <template #footer>
      <BaseButton type="default" @click="remove">取消</BaseButton>
      <BaseButton @click="onConfirm">下一步</BaseButton>
    </template>
  </BaseDialog>
</template>
<script lang="tsx" setup>
import { ref, withDefaults, defineProps, computed, defineEmits } from 'vue';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  useSelectColumn,
  BaseButton,
  BaseDialog,
  BaseTextContent,
  useCreateModal,
  XrkMessage
} from 'xrk-components';
import { formatter } from '@/utils';
import { PAY_PASSAGEWAY_MAPPING } from '@/common/constants/bank';
import { notInvoicedList } from '@V/invoice/src/data-source/apis';
import { ORDER_TYPE } from '@constants/order';
import InvoiceWtdk2Dialog from './invoice-wtdk-2-dialog.vue';
import InvoiceWtdk3Dialog from './invoice-wtdk-3-dialog.vue';

const props = withDefaults(
  defineProps<{
    remove?: () => {};
  }>(),
  {}
);
const emits = defineEmits<{
  (event: 'success'): void;
}>();

const xrkTableRef = ref();
const totalPrice = ref(0);

const selections = computed(() => {
  return xrkTableRef.value?.getSelectionRows?.() || [];
});
// 统计订单中所选人的金额
const selectionUserDefinedPrice = computed(() => {
  // 最终计算订单中所选人的金额
  // 合并item中人集合数据，
  return selections.value.reduce((pre, cur) => {
    return (
      pre +
      cur._selections.reduce((childPre, childCur) => {
        return childPre + childCur.userDefinedPrice;
      }, 0)
    );
  }, 0);
});

const getListAjax = async params => {
  // 委托代开写死入参
  const resp = await notInvoicedList({
    ...params,
    stateType: 2,
    userDefinedOrderType: 1
  });
  totalPrice.value = resp.data.totalPrice;
  return resp;
};

const onConfirm = () => {
  if (!selections.value.length) {
    XrkMessage.error('请选择订单');
    return;
  }
  useCreateModal(InvoiceWtdk3Dialog, {
    orders: selections.value,
    onSuccess() {
      emits('success');
      props.remove();
    }
  });
};

const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchColumns: [
    useSelectColumn({
      prop: 'payPassagewayCode',
      label: '支付通道',
      config: {
        placeholder: '请选择',
        options: PAY_PASSAGEWAY_MAPPING
      }
    })
  ],
  searchBtn: {
    show: true,
    text: '搜索',
    beforeSearch() {
      xrkTableRef.value.initList();
      return Promise.reject();
    }
  },
  resetBtn: {
    show: false,
    text: '重置'
  }
});

const tableConfig = ref<XrkTableProps['tableConfig']>({
  baseConfig: { rowKey: '_id' },
  tableColumns: [
    useTableColumn({
      type: '_selection',
      prop: '_id',
      align: 'center',
      fixed: 'left',
      width: 110,
      selectionDisabled: (row: any) => !row._selections.length
    }),
    useTableColumn({
      type: 'index',
      label: '序号',
      width: '80px'
    }),
    useTableColumn({
      label: '订单编号',
      prop: 'userDefinedOrderNo'
    }),
    useTableColumn({
      label: '支付通道',
      prop: 'payPassagewayCode',
      formatter: ({ cellValue }) =>
        formatter.defaultFormat(
          cellValue,
          () => PAY_PASSAGEWAY_MAPPING[cellValue].label
        )
    }),
    useTableColumn({
      label: '订单类型',
      prop: 'userDefinedOrderType',
      formatter: ({ cellValue }) =>
        formatter.defaultFormat(cellValue, () => ORDER_TYPE[cellValue].label)
    }),
    useTableColumn({
      label: '已选人数',
      prop: 'applicationNum',
      render: ({ row }) => {
        return (
          <BaseButton
            type="text"
            onClick={() => {
              useCreateModal(InvoiceWtdk2Dialog, {
                userDefinedOrderId: row.userDefinedOrderId,
                selections: row._selections,
                onSuccess(people) {
                  row._selections = people;
                }
              });
            }}
          >{`${row._selections.length}/${row.applicationNum}`}</BaseButton>
        );
      }
    }),
    useTableColumn({
      label: '可开票金额(元)',
      prop: 'userDefinedPrice',
      width: '140px',
      formatter: ({ cellValue }) => formatter.fen2yuan(cellValue)
    }),
    useTableColumn({
      label: '已选开票金额(元)',
      prop: '_selections',
      width: '150px',
      formatter: ({ cellValue }) =>
        formatter.fen2yuan(
          cellValue.reduce((pre, cur) => {
            return pre + cur.userDefinedPrice;
          }, 0)
        )
    })
  ]
});
</script>
